import { render, staticRenderFns } from "./AiTutorHero.vue?vue&type=template&id=05c96a62&scoped=true&"
import script from "./AiTutorHero.vue?vue&type=script&lang=js&"
export * from "./AiTutorHero.vue?vue&type=script&lang=js&"
import style0 from "./AiTutorHero.vue?vue&type=style&index=0&id=05c96a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c96a62",
  null
  
)

export default component.exports